<nav class="sticky-header nav-bar">
  <div class="px-0">
    <div class="relative flex items-center py-3">
      <!-- LEFT: brand -->
      <div class="flex items-center gap-3 pl-4 md:pl-6 pr-4">
        <img
          class="h-10 md:h-12 w-auto object-contain shrink-0"
          src="assets/images/EV Intelligence logo.png"
          alt="EVE Intelligence"
        />
      </div>

      @if (!isAuthPage) {
        <!-- CENTER: desktop menu (hidden on mobile/tablet) -->
        <div class="hidden lg:block absolute left-1/2 -translate-x-1/2">
          <div class="flex items-center space-x-1">

            <!-- Home link: public only -->
            @if (!isLoggedIn) {
              <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" ariaCurrentWhenActive="page" class="nav-link">Home</a>
            }

            <!-- Login link (unauthenticated only) -->
            @if (!isLoggedIn) {
              <a routerLink="/login" routerLinkActive="active" class="nav-link">Login</a>
            }

            <!-- Dashboard link (authenticated) -->
            @if (isLoggedIn && authService.has('tableaudashboard', 'canview')) {
              <a routerLink="/dashboard" routerLinkActive="active" ariaCurrentWhenActive="page" class="nav-link">Dashboard</a>
            }

            <!-- Hub link: authenticated only -->
            @if (isLoggedIn) {
              <a routerLink="/hub" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" ariaCurrentWhenActive="page" class="nav-link">Hub</a>
            }

            <!-- Data Management dropdown (authenticated + permissionLoaded) -->
            @if (isLoggedIn) {
              <div class="relative">
                <button type="button" class="nav-link"
                  (click)="toggleDropdown('datamanagement', $event)"
                  [attr.aria-expanded]="openDropdown === 'datamanagement'"
                  aria-haspopup="true">Data Management</button>
                @if (openDropdown === 'datamanagement' && isLoggedIn && permissionLoaded) {
                  <div class="absolute z-10 mt-1 w-52 nav-dropdown">
                    <div class="py-1" role="menu">

                      <!-- Upload Data fly-out -->
                      @if (authService.has('uploaddata', 'canview')) {
                      <div class="nav-flyout-item">
                        <div class="nav-flyout-trigger" role="menuitem" aria-haspopup="true">
                          Upload Data
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                               stroke-width="2" stroke="currentColor" style="width:14px;height:14px;flex-shrink:0;">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5"/>
                          </svg>
                        </div>
                        <div class="nav-flyout-submenu nav-dropdown">
                          <div class="py-1" role="menu">
                            <a routerLink="/waste-data/waste-data" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'upload-wastedata', flag: 'canexecute' }">Waste Data</a>
                            <a routerLink="/waste-data/profiling_pfo" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'upload-profilingpfo', flag: 'canexecute' }">Profiling - Processing Facility Outcome</a>
                            <a routerLink="/waste-data/profiling_mso" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'upload-profilingmso', flag: 'canexecute' }">Profiling - Material Stream Output</a>
                            <a routerLink="/waste-data/contract_service" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'upload-contractservice', flag: 'canexecute' }">Contract Service</a>
                            <a routerLink="/waste-data/custom_density" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'upload-customdensity', flag: 'canexecute' }">Custom Density</a>
                            <a routerLink="/waste-data/itemcode" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'upload-itemcode', flag: 'canexecute' }">Item Code</a>
                          </div>
                        </div>
                      </div>
                      }

                      <!-- Review & Approve Data fly-out -->
                      @if (authService.has('review-n-approved', 'canview')) {
                      <div class="nav-flyout-item">
                        <div class="nav-flyout-trigger" role="menuitem" aria-haspopup="true">
                          Review &amp; Approve Data
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                               stroke-width="2" stroke="currentColor" style="width:14px;height:14px;flex-shrink:0;">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5"/>
                          </svg>
                        </div>
                        <div class="nav-flyout-submenu nav-dropdown">
                          <div class="py-1" role="menu">
                            <a routerLink="/review-data/wastedata-review" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'rna-wastedatareview', flag: 'canview' }">Waste Data</a>
                            <a routerLink="/review-data/open-periods" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'rna-openperiods', flag: 'canview' }">Open Periods</a>
                            <a routerLink="/review-data/lock-periods" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'rna-lockperiods', flag: 'canview' }">Lock Periods</a>
                          </div>
                        </div>
                      </div>
                      }

                      <!-- Data Setup fly-out -->
                      @if (authService.has('datasetup', 'canview')) {
                      <div class="nav-flyout-item">
                        <div class="nav-flyout-trigger" role="menuitem" aria-haspopup="true">
                          Data Setup
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                               stroke-width="2" stroke="currentColor" style="width:14px;height:14px;flex-shrink:0;">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5"/>
                          </svg>
                        </div>
                        <div class="nav-flyout-submenu nav-dropdown">
                          <div class="py-1" role="menu">
                            <a routerLink="/master-data/asset" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'asset', flag: 'canview' }">Asset</a>
                            <a routerLink="/master-data/ownership" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'ownership', flag: 'canview' }">Ownership</a>
                            <a routerLink="/master-data/waste-contract" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'wastecontract', flag: 'canview' }">Waste Contract</a>
                            <a routerLink="/master-data/waste-contractor" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'wastecontractor', flag: 'canview' }">Waste Contractor</a>
                            <a routerLink="/master-data/equipment" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'equipment', flag: 'canview' }">Equipment</a>
                            <a routerLink="/master-data/material-stream-input" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'msi', flag: 'canview' }">Material Stream Input</a>
                            <a routerLink="/master-data/ownership-entity" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'ownershipentity', flag: 'canview' }">Ownership Entity</a>
                            <a routerLink="/master-data/custom-density" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'customdensity', flag: 'canview' }">Custom Density</a>
                            <a routerLink="/master-data/standard-density" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'standarddensity', flag: 'canview' }">Standard Density</a>
                            <a routerLink="/master-data/proc-facility-profiling" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'profilingpfo', flag: 'canview' }">Processing Facility Outcome</a>
                            <a routerLink="/master-data/mso-profiling" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'profilingmso', flag: 'canview' }">Material Stream Output Profiling</a>
                            <a routerLink="/master-data/profile" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()" *appPermission="{ entity: 'profile', flag: 'canview' }">Profile</a>
                          </div>
                        </div>
                      </div>
                      }

                    </div>
                  </div>
                }
              </div>
            }

            <!-- Reports dropdown (admin only) -->
            @if (isLoggedIn && (authService.has('loginreport', 'canview') || authService.has('auditlogs', 'canview'))) {
              <div class="relative">
                <button type="button" class="nav-link"
                  (click)="toggleDropdown('reports', $event)"
                  [attr.aria-expanded]="openDropdown === 'reports'"
                  aria-haspopup="true">Reports</button>
                @if (openDropdown === 'reports') {
                  <div class="absolute z-10 mt-1 w-52 nav-dropdown">
                    <div class="py-1" role="menu">
                      @if (authService.has('loginreport', 'canview')) {
                        <a routerLink="/reports/login-report"
                           routerLinkActive="active"
                           class="nav-dropdown-link"
                           role="menuitem"
                           (click)="closeDropdown()">Login History</a>
                      }
                      @if (authService.has('auditlogs', 'canview')) {
                        <a routerLink="/reports/audit-logs"
                           routerLinkActive="active"
                           class="nav-dropdown-link"
                           role="menuitem"
                           (click)="closeDropdown()">Audit Logs</a>
                      }
                    </div>
                  </div>
                }
              </div>
            }

            <!-- Account dropdown (authenticated) -->
            @if (isLoggedIn) {
              <div class="relative">
                <button type="button" class="nav-link"
                  (click)="toggleDropdown('account', $event)"
                  [attr.aria-expanded]="openDropdown === 'account'"
                  aria-haspopup="true">Account</button>
                @if (openDropdown === 'account') {
                  <div class="absolute right-0 z-10 mt-1 w-48 nav-dropdown">
                    <div class="py-1" role="menu">
                      <a routerLink="/audit-support" routerLinkActive="active" class="nav-dropdown-link" role="menuitem" (click)="closeDropdown()">Help &amp; Support</a>
                      <button type="button" class="nav-dropdown-link w-full text-left" role="menuitem" (click)="logout(); closeDropdown()">Log Out</button>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>

        <!-- RIGHT: hamburger (mobile/tablet only) -->
        <div class="ml-auto pr-4 lg:hidden">
          <button
            (click)="openMenu($event)"
            type="button"
            aria-label="Open navigation menu"
            style="display: inline-flex; align-items: center; justify-content: center; width: 40px; height: 40px; border: none; background: transparent; color: #4d68aa; cursor: pointer; border-radius: var(--radius-sm);"
          >
            <svg style="width:24px;height:24px;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16"/>
            </svg>
          </button>
        </div>

        <!-- Desktop right spacer -->
        <div class="hidden lg:block ml-auto"></div>
      }
    </div>
  </div>
  <!-- 4px accent bar below nav content -->
  <div class="nav-accent-bar"></div>
</nav>

@if (showLogoutConfirm) {
  <div class="confirm-backdrop" (click)="cancelLogout()">
    <div class="confirm-dialog" (click)="$event.stopPropagation()">
      <svg class="confirm-icon" style="color: var(--color-primary);" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15" />
      </svg>
      <p class="confirm-title">Log Out</p>
      <p class="confirm-message">Are you sure you want to log out?</p>
      <div class="confirm-actions">
        <button class="btn-secondary" (click)="cancelLogout()">Cancel</button>
        <button class="btn" (click)="confirmLogout()">Log Out</button>
      </div>
    </div>
  </div>
}

<!-- ─── MOBILE NAV DRAWER ─── -->
@if (isMenuOpen) {
  <div class="mobile-nav-backdrop lg:hidden" (click)="closeMenu($event)"></div>
  <nav class="mobile-nav-drawer open lg:hidden" aria-label="Mobile navigation">
    <div class="mobile-nav-header">
      <div class="flex items-center gap-2">
        <img src="assets/images/EV Intelligence logo.png" alt="EVE Intelligence" style="height:32px;width:auto;object-fit:contain;" />
      </div>
      <button
        (click)="closeMenu($event)"
        aria-label="Close navigation menu"
        style="display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;border:none;background:transparent;color:#4d68aa;cursor:pointer;border-radius:var(--radius-sm);"
      >
        <svg style="width:20px;height:20px;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <div style="overflow-y:auto;flex:1;">
      <!-- Home: public only -->
      @if (!isLoggedIn) {
        <p class="mobile-nav-section">Home</p>
        <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="mobile-nav-sub-link" (click)="onSubmenuSelect('/')">Home</a>
      }

      <!-- Login (unauthenticated only) -->
      @if (!isLoggedIn) {
        <p class="mobile-nav-section">Account</p>
        <a routerLink="/login" routerLinkActive="active" class="mobile-nav-sub-link" (click)="onSubmenuSelect('/login')">Login</a>
      }

      <!-- Dashboard -->
      @if (isLoggedIn && authService.has('tableaudashboard', 'canview')) {
        <p class="mobile-nav-section">Dashboard</p>
        <a routerLink="/dashboard" routerLinkActive="active"
           class="mobile-nav-sub-link"
           (click)="onSubmenuSelect('/dashboard')">Dashboard</a>
      }

      <!-- Hub: authenticated only -->
      @if (isLoggedIn) {
        <p class="mobile-nav-section">Hub</p>
        <a routerLink="/hub" routerLinkActive="active" class="mobile-nav-sub-link" (click)="onSubmenuSelect('/hub')">Hub</a>
      }

      <!-- Data Management -->
      @if (isLoggedIn && permissionLoaded) {
        <p class="mobile-nav-section">Data Management</p>
        @if (authService.has('uploaddata', 'canview')) {
        <p class="mobile-nav-sub-section">Upload Data</p>
        <a routerLink="/waste-data/waste-data" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/waste-data/waste-data')" *appPermission="{ entity: 'upload-wastedata', flag: 'canexecute' }">Waste Data</a>
        <a routerLink="/waste-data/profiling_pfo" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/waste-data/profiling_pfo')" *appPermission="{ entity: 'upload-profilingpfo', flag: 'canexecute' }">Profiling - Processing Facility Outcome</a>
        <a routerLink="/waste-data/profiling_mso" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/waste-data/profiling_mso')" *appPermission="{ entity: 'upload-profilingmso', flag: 'canexecute' }">Profiling - Material Stream Output</a>
        <a routerLink="/waste-data/contract_service" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/waste-data/contract_service')" *appPermission="{ entity: 'upload-contractservice', flag: 'canexecute' }">Contract Service</a>
        <a routerLink="/waste-data/custom_density" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/waste-data/custom_density')" *appPermission="{ entity: 'upload-customdensity', flag: 'canexecute' }">Custom Density</a>
        <a routerLink="/waste-data/itemcode" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/waste-data/itemcode')" *appPermission="{ entity: 'upload-itemcode', flag: 'canexecute' }">Item Code</a>
        }
        @if (authService.has('review-n-approved', 'canview')) {
        <p class="mobile-nav-sub-section">Review &amp; Approve Data</p>
        <a routerLink="/review-data/wastedata-review" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/review-data/wastedata-review')" *appPermission="{ entity: 'rna-wastedatareview', flag: 'canview' }">Waste Data</a>
        <a routerLink="/review-data/open-periods" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/review-data/open-periods')" *appPermission="{ entity: 'rna-openperiods', flag: 'canview' }">Open Periods</a>
        <a routerLink="/review-data/lock-periods" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/review-data/lock-periods')" *appPermission="{ entity: 'rna-lockperiods', flag: 'canview' }">Lock Periods</a>
        }
        @if (authService.has('datasetup', 'canview')) {
        <p class="mobile-nav-sub-section">Data Setup</p>
        <a routerLink="/master-data/asset" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/master-data/asset')" *appPermission="{ entity: 'asset', flag: 'canview' }">Asset</a>
        <a routerLink="/master-data/ownership" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/master-data/ownership')" *appPermission="{ entity: 'ownership', flag: 'canview' }">Ownership</a>
        <a routerLink="/master-data/waste-contract" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/master-data/waste-contract')" *appPermission="{ entity: 'wastecontract', flag: 'canview' }">Waste Contract</a>
        <a routerLink="/master-data/waste-contractor" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/master-data/waste-contractor')" *appPermission="{ entity: 'wastecontractor', flag: 'canview' }">Waste Contractor</a>
        <a routerLink="/master-data/equipment" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/master-data/equipment')" *appPermission="{ entity: 'equipment', flag: 'canview' }">Equipment</a>
        <a routerLink="/master-data/material-stream-input" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/master-data/material-stream-input')" *appPermission="{ entity: 'msi', flag: 'canview' }">Material Stream Input</a>
        <a routerLink="/master-data/ownership-entity" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/master-data/ownership-entity')" *appPermission="{ entity: 'ownershipentity', flag: 'canview' }">Ownership Entity</a>
        <a routerLink="/master-data/custom-density" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/master-data/custom-density')" *appPermission="{ entity: 'customdensity', flag: 'canview' }">Custom Density</a>
        <a routerLink="/master-data/standard-density" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/master-data/standard-density')" *appPermission="{ entity: 'standarddensity', flag: 'canview' }">Standard Density</a>
        <a routerLink="/master-data/proc-facility-profiling" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/master-data/proc-facility-profiling')" *appPermission="{ entity: 'profilingpfo', flag: 'canview' }">Processing Facility Outcome</a>
        <a routerLink="/master-data/mso-profiling" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/master-data/mso-profiling')" *appPermission="{ entity: 'profilingmso', flag: 'canview' }">Material Stream Output Profiling</a>
        <a routerLink="/master-data/profile" routerLinkActive="active" class="mobile-nav-sub-link" style="padding-left:32px" (click)="onSubmenuSelect('/master-data/profile')" *appPermission="{ entity: 'profile', flag: 'canview' }">Profile</a>
        }
      }

      <!-- Reports (admin only) -->
      @if (isLoggedIn && (authService.has('loginreport', 'canview') || authService.has('auditlogs', 'canview'))) {
        <p class="mobile-nav-section">Reports</p>
        @if (authService.has('loginreport', 'canview')) {
          <a routerLink="/reports/login-report"
             routerLinkActive="active"
             class="mobile-nav-sub-link"
             (click)="onSubmenuSelect('/reports/login-report')">Login History</a>
        }
        @if (authService.has('auditlogs', 'canview')) {
          <a routerLink="/reports/audit-logs"
             routerLinkActive="active"
             class="mobile-nav-sub-link"
             (click)="onSubmenuSelect('/reports/audit-logs')">Audit Logs</a>
        }
      }

      <!-- Account -->
      @if (isLoggedIn) {
        <p class="mobile-nav-section">Account</p>
        <a routerLink="/audit-support" routerLinkActive="active" class="mobile-nav-sub-link" (click)="onSubmenuSelect('/audit-support')">Help &amp; Support</a>
        <a (click)="logout()" class="mobile-nav-sub-link" style="cursor:pointer;">Log Out</a>
      }
    </div>
  </nav>
}
